import script from "./VariantSwitchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantSwitchModal.vue?vue&type=script&setup=true&lang=js"

import "./VariantSwitchModal.vue?vue&type=style&index=0&id=fee69f48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee69f48"]])

export default __exports__